<template>
    <div class="bg_load_null box_pipeline" @click="editing = true" @keydown.esc.stop="editing = false" v-pml-block="isLoading">
        <textarea v-model="cache" v-if="editing" @change.prevent="update" @keydown.enter.prevent="update" v-pml-focus maxlength="30"></textarea>
        <span class="pipeline_name" v-if="!editing">{{ item.name }}</span>
        <a @click="askToDeleteSteps()" class="btn btn-xs btn-danger" v-if="!editing" v-pml-tooltip.left="$t('delete')"><i class="fa fa-times"></i></a>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { destroy, update } from 'services/pipeline-steps'
    import { askToDeleteSteps } from 'utils/helpers/sweet-alert'

    export default {
        name: 'PipelineStepsItem',
        props: [ 'item' ],
        data () {
            return {
                cache: this.item.name,
                editing: false,
                isLoading: false
            }
        },
        watch: {
            item (val) {
                this.cache = val.name
            }
        },
        methods: {
            update () {
                this.editing = false

                if (this.cache !== this.item.name) {
                    this.isLoading = true

                    update(this.item.pipeline_id, this.item.id, { name: this.cache })
                        .then(() => {
                            this.$emit('fetchPipeline', this.item.pipeline_id)
                        })
                        .catch(error => {
                            this.cache = this.item.name
                            Notify.error(trans(error.response.data.name[0]))
                        })
                        .then(() => {
                            this.isLoading = false
                        })
                }
            },
            askToDeleteSteps () {
                askToDeleteSteps()
                    .then((response) => (response.value) ? this.destroy() : null)
            },
            destroy () {
                this.isLoading = true

                destroy(this.item.pipeline_id, this.item.id)
                    .then(() => { this.$emit('fetchPipeline', this.item.pipeline_id) })
                    .catch(error => Notify.error(trans(error.response.data.slug)))
                    .then(() => { this.isLoading = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/parameters/pipelines/components/StepItem.vue